import { render, staticRenderFns } from "./stockFlowDetail.vue?vue&type=template&id=6e4f9220&scoped=true"
import script from "./stockFlowDetail.vue?vue&type=script&lang=js"
export * from "./stockFlowDetail.vue?vue&type=script&lang=js"
import style0 from "./stockFlowDetail.vue?vue&type=style&index=0&id=6e4f9220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4f9220",
  null
  
)

export default component.exports